import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Table from 'components/Table/index';
import { fetchGetHistoricoRelatorioRequerimentos } from 'store/fetchActions/fetchRelatorios';
import { Button, Space } from 'antd';

export default function GridRequerimento({ filtros, handlePesquisar }) {
  const dispatch = useDispatch();

  const dadosGrid = useSelector(state => state.relatorios.todosRequerimentos?.list);
  const paginacao = useSelector(state => state.relatorios.todosRequerimentos);

  const montarLinha = lista => {
    return lista?.map(item => {
      return {
        key: item?.formularioId,
        protocolo: item?.protocolo,
        tipoPessoa: item?.tipoPessoa,
        dataAbertura: item?.dataAbertura,
        dataEncerramento: item?.dataEncerramento || '-',
        status: item?.status || '-',
        assunto: item?.assunto || '-',
        servico: item?.servico || '-',
        atendente: item?.atendente || '-',
        setor: item?.setor || '-',
      };
    });
  };

  const changePage = (page = 1, pageSize = 10) => {
    handlePesquisar(filtros, page, pageSize);
  };

  const renderAction = row => {
    return (
      <Space>
        <Button onClick={() => dispatch(fetchGetHistoricoRelatorioRequerimentos(row?.key))}>Histórico</Button>
      </Space>
    );
  };

  const columns = [
    {
      title: 'Protocolo',
      dataIndex: 'protocolo',
      key: 'protocolo',
    },
    {
      title: 'Tipo de Pessoa',
      dataIndex: 'tipoPessoa',
      key: 'tipoPessoa',
    },
    {
      title: 'Data de Abertura',
      dataIndex: 'dataAbertura',
      key: 'dataAbertura',
    },
    {
      title: 'Data Encerramento',
      dataIndex: 'dataEncerramento',
      key: 'dataEncerramento',
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
    },
    {
      title: 'Assunto',
      dataIndex: 'assunto',
      key: 'assunto',
    },
    {
      title: 'Serviço',
      key: 'servico',
      dataIndex: 'servico',
    },
    {
      title: 'Atendente',
      key: 'atendente',
      dataIndex: 'atendente',
    },
    {
      title: 'Setor',
      key: 'setor',
      dataIndex: 'setor',
    },
    {
      title: '-',
      key: 'action',
      align: 'center',
      render: record => renderAction(record),
    },
  ];

  return <Table columns={columns} data={montarLinha(dadosGrid)} paginationConfig={paginacao} changePage={changePage} />;
}
